import React, {useState} from "react";
import styled from "styled-components";
import TableComponent from "../../common/components/TableComponent";
import {getSignedURL} from "../../managers/awsService";
import DeleteDialogComponent from "../deleteDialog";
import EditDialogComponent from "../editDialog";

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const ComponentHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: max-content;
  justify-content: space-between;
`;
const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  font-size: 22px;
  align-items: center;
`;
const AddNewButton = styled.button`
  font-family: MuseoSans;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  background-color: #832729;
  color: white;
  white-space: nowrap;
  padding: 8px 10px;
  border: none;
  outline: none;
`;
export const ThumbnailImg = styled.img`
  width: 42px;
  height: 42px;
  object-fit: contain;
`;
export const DeleteIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`

function BannersComponent(props) {
    const {state, refreshList} = props;
    const [selectedCategory, setSelectedCategory] = useState("");
    return (
        <MainContainer>
            <ComponentHeader>
                <SearchContainer>
                    Banners
                </SearchContainer>
                <AddNewButton onClick={props.onAddNewAdvertiserClicked}>
                    Add Banner
                </AddNewButton>
            </ComponentHeader>
            <TableComponent.Table cellpadding="0" cellspacing="0">
                <TableComponent.TableHead>
                    <TableComponent.HeadColumn>Media</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn>Name</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn>Category</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn/>
                    <TableComponent.HeadColumn/>
                </TableComponent.TableHead>
                <TableComponent.TableBody>
                    {state?.bannerList?.map((banner) => (
                        <TableComponent.BodyRow
                            key={banner._id}
                            onClick={() =>
                                setSelectedCategory(selectedCategory ? "" : banner._id)
                            }
                        >
                            <TableComponent.BodyColumn>
                                <ThumbnailImg src={getSignedURL(banner.media)}/>
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                {banner.name}
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                {banner.categoryName}
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                <EditDialogComponent entityName="banner" data={banner}
                                                     refreshList={refreshList}/>
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                <DeleteDialogComponent entityName="banner" id={banner._id}
                                                       refreshList={refreshList}/>
                            </TableComponent.BodyColumn>
                        </TableComponent.BodyRow>
                    ))}
                </TableComponent.TableBody>
            </TableComponent.Table>
        </MainContainer>
    );
}

export default BannersComponent;
